import { render, staticRenderFns } from "./PaymentLink.vue?vue&type=template&id=0b92b843&scoped=true&"
import script from "./PaymentLink.vue?vue&type=script&lang=js&"
export * from "./PaymentLink.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLink.vue?vue&type=style&index=0&id=0b92b843&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b92b843",
  null
  
)

/* custom blocks */
import block0 from "./PaymentLink.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports